<template>
  <div>
    <DxDataGrid
      :show-borders="true"
      :column-auto-width="true"
      :data-source="item.details"
    >
      <DxColumn caption="CATEGORIA" data-field="categoria" />
      <DxColumn caption="STATO" data-field="stato" />
      <DxColumn caption="CFP" data-field="cfp" />
      <DxColumn
        caption="SCADENZA CREDITI"
        data-field="scadenzaCrediti"
        type="date"
      />
    </DxDataGrid>
  </div>
</template>

<script>
import 'devextreme/data/odata/store'
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'

export default {
  name: 'EcPassELearningDetail',
  components: {
    DxDataGrid,
    DxColumn,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    item: Object,
  },
  data: () => ({
    detail: [],
    errors: [],
  }),
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.button {
  background: rgb(0, 158, 220);
}
a {
  background: rgb(0, 158, 220);
}
.filter-row {
  display: flex;
  align-items: baseline;
}
.filter-element {
  padding-left: 1rem;
}
</style>
<style>
.dx-texteditor-input {
  margin: 0 !important;
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.87) !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -webkit-appearance: none !important;
  outline: 0 !important;
  border: 0 !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}
</style>
